module.exports = __webpack_public_path__ + "assets/img/solution6.f9b6e181.png";